import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import {
    RATE_CREATE_PAGE_LOADED,
    RATE_CREATE,
    RATE_CREATE_PAGE_UNLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.settings,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
});

const mapDispatchToProps = dispatch => ({
    onSubmit: (payload) => {
        dispatch({ type: RATE_CREATE, payload })
    },
    onUnload: () =>
        dispatch({ type: RATE_CREATE_PAGE_UNLOADED })
});

class RateAdd extends React.Component {
    constructor() {
        super();
        this.state = {
            symbol: '',
            rate: '',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (symbol, rate) => ev => {
            ev.preventDefault();
            const payload = agent.Rates.createRate(symbol, rate)
            this.props.onSubmit(payload);
        }
    }
    componentWillMount(props) {
        if (this.props.currentUser) {
            Object.assign(this.state, {
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        const symbol = this.state.symbol;
        const rate = this.state.rate;
        const inProgress = this.props.inProgress
        return (
            <div class='pane'>
                <Link className="crumb" to="/rates">&laquo; back to rates</Link>
                <h1>Add rate</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(symbol, rate)}>
                    <fieldset className="form">
                        <strong>Symbol</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Symbol"
                                value={symbol}
                                onChange={this.updateState('symbol')} />
                        </fieldset>
                        <strong>Rate</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="5500"
                                value={rate}
                                onChange={this.updateState('rate')} />
                        </fieldset>


                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Add
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RateAdd);



// WEBPACK FOOTER //
// ./src/components/RateAdd.js